import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Grid, Hidden } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import Backlink from "../search/view/_back-link";
import { searchSubmit } from "../content-section/model/content-actions";
import {adminService} from "../../../services/admin.service"

// Commented this code related to Reducers on 27-05-2021
    
    // useEffect(() => {
    //   window.scrollTo(0, 0);
    //   setfaqResults(faqs?.data?.getContents?.FAQ_AUTH.Default);
    // }, []);
//.......................................................

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "70px",
  },
  stacktop: {
    position: "absolute",
    top: "20%",
    right: "7%",
    left: "7%",
    borderRadius: "12px",
  },
  quinaryBackground: {
    background: theme.palette.quinary.main + "!important",
    width: "-webkit-fill-available !important",
    position: "absolute",
    height: "-webkit-fill-available !important",
    height: "110% !important",
  },
  primaryBackground: {
    background: theme.palette.ePrimary.base + " !important",
    width: "-webkit-fill-available !important",
    minHeight: "30vh",
  },
  search: {
    padding: "2%",
  },
  hrLine: {
    border: 0,
    clear: "both",
    display: "block",
    width: "100%",
    backgroundColor: "lightgray",
    height: "1px",
  },
  heading: {
    minWidth: "250px",
    width: "auto",
    padding: 0,
  },
  headingGrid: {
    display: "flex",
    flexDirection: "row",
  },
  contentGrid: {
    marginTop: "1%",
    marginLeft: "5px",
  },
  expansionPanel: {
    border: "1px solid lightgrey",
  },
  searchBar: {
    width: "60%",
    height: "80%",
    margin: "auto",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  smSearchBar: {
    width: "100%",
    height: "80%",
    margin: "auto",
  },
}));

export default function Search() {
  const classes = useStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 960px)" });
  const smQuery = useMediaQuery({ query: "(min-width: 780px)" });
  const [faqResults, setfaqResults] = useState([]);
  const faqs = useSelector((state) => state.faqs?.faqResults);
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  //New added code when the removal of Reducer related....Above commented one reducer related
  const languageCode = useSelector(
      (state) =>
        state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
    );
  useEffect(() => {
    if(languageCode){
      window.scrollTo(0, 0);
      (async()=>{
        await adminService.getContentData(languageCode, "FAQ_AUTH").then((res) => {
          setfaqResults(res.data.getContents.FAQ_AUTH.Default?res.data.getContents.FAQ_AUTH.Default:res.data.getContents.FAQ_AUTH);
        });
      })()
    }
  }, [languageCode]);
  //Up to here......................
  const handleSubmitSearch = (keyword) => {
    dispatch(searchSubmit(keyword));
  };

  return (
    <div className={classes.root}>
      <React.Fragment>
        {isTabletOrMobile ? (
          <React.Fragment>
            <Grid container direction="column">
              <Grid item>
                <div className={classes.primaryBackground} />
              </Grid>
              <Grid item>
                <div className={classes.quinaryBackground} />
              </Grid>
            </Grid>
            <Card className={classes.stacktop}>
              <CardContent>
                <Grid
                  container
                  alignItems="center"
                  justify="space-between"
                  direction="row"
                >
                  <Grid item xs={1}>
                    <Backlink />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      color="primary"
                      gutterBottom
                      variant="h6"
                      component="h2"
                      align="center"
                      className="margin-top-10"
                    >
                      <b>{labels?.SEARCH_FAQS}</b>
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={1}>
                    <div>
                      {" "}
                      <br />
                    </div>
                  </Grid> */}
                </Grid>

                <hr />

                <Grid container justify="center">
                  {faqResults?.length > 0 ? (
                    <React.Fragment>
                      <Grid
                        className={classes.contentGrid}
                        direction="column"
                        spacing={2}
                        container
                        item
                        alignItems="center"
                        xs={12}
                      >
                        <Grid item spacing={4} container>
                          {faqResults.map((item, index) => {
                            return (
                              <Grid key={index + 1} xs={12} sm={6} item>
                                <ExpansionPanel
                                  className={classes.expansionPanel}
                                  expanded={expanded === index} onChange={handleChange(index)}
                                >
                                  <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                  >
                                    <Typography color="textPrimary">
                                    {item.question.length > 60 && expanded === false ? item.question.split(" ",10).join(" ") + " ..." :item.question}
                                    </Typography>
                                  </ExpansionPanelSummary>
                                  <ExpansionPanelDetails>
                                    {item.contentGroup === "TEXT" ? (
                                      <Typography color="textSecondary">
                                        {item.answer}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        color="textSecondary"
                                        variant="h6"
                                        align="center"
                                        dangerouslySetInnerHTML={{
                                          __html: item.answer,
                                        }}
                                      />
                                    )}
                                  </ExpansionPanelDetails>
                                </ExpansionPanel>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  ) : null}
                </Grid>
              </CardContent>
            </Card>
          </React.Fragment>
        ) : (
          <div className={classes.search}>
            <Card>
              <CardContent>
                <Backlink backToHome={true} />
                <Grid container justify="center" className="margin-top-10">
                  {faqResults?.length > 0 ? (
                    <React.Fragment>
                      <Grid item xs={12}>
                        <Typography
                          color="primary"
                          variant="h5"
                          component="h2"
                          align="center"
                        >
                          <b>{labels?.SEARCH_FAQS}</b>
                        </Typography>
                      </Grid>

                      <Grid
                        className={classes.contentGrid}
                        direction="column"
                        spacing={2}
                        container
                        item
                        alignItems="center"
                        xs={12}
                      >
                        <Grid item spacing={4} container>
                          {faqResults.map((item, index) => {
                            return (
                              <Grid key={index + 1} xs={12} sm={6} item>
                                <ExpansionPanel
                                  className={classes.expansionPanel}
                                >
                                  <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                  >
                                    <Typography color="textPrimary">
                                      {item.question}
                                    </Typography>
                                  </ExpansionPanelSummary>
                                  <ExpansionPanelDetails>
                                    {item.contentGroup === "TEXT" ? (
                                      <Typography color="textSecondary">
                                        {item.answer}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        color="textSecondary"
                                        variant="h6"
                                        align="center"
                                        dangerouslySetInnerHTML={{
                                          __html: item.answer,
                                        }}
                                      />
                                    )}
                                  </ExpansionPanelDetails>
                                </ExpansionPanel>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  ) : null}
                </Grid>
              </CardContent>
            </Card>
          </div>
        )}
      </React.Fragment>
    </div>
  );
}
